import React, { useEffect } from "react";
import PropTypes from "prop-types";
import MissingGif from "../../assets/animated/404.gif";

import "../../styles/404.scss";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components";

const MissingPage = (props) => {
  const navigate = useNavigate();

  return (
    <div className="missing-404">
      <img className="missing-404__image" alt="404" src={MissingGif} />
      <Button
        label={"Return to Homepage"}
        variant={"secondary"}
        onClick={() => navigate("/")}
      />
    </div>
  );
};

MissingPage.propTypes = {};

export default MissingPage;
